const { field, loanPurpose } = require('@enums');

module.exports = {
  //////////////////////////
  // API
  //////////////////////////

  DYNAMIC_RATES_ENDPOINT: '/apis/mortgageratesapi/fetchrates',
  RACK_RATES_ENDPOINT: '/apis/mortgageratesapi/fetchrackrates',
  VALIDATE_ZIP_CODE_ENDPOINT: '/apis/mortgageratesapi/validatezipcode',
  SAVE_LOAN_DATA_ENDPOINT: '/apis/mortgageratesapi/saveloandata',

  // If requesting many product types
  // at once, we split it into multiple
  // requests so that rates can start
  // filling the table as they come in
  INITIAL_REQUEST_CHUNK_SIZE: 4,

  // When the user edits their loan details,
  // we prefretch rates before they click
  // the refresh button. This is the delay
  // between when a field is edited and
  // when data is prefetched
  SCENARIO_PREFETCH_DELAY: 700,

  // We validate that the user's zip code is
  // within our lending footprint using an
  // API route. To avoid repeated requests,
  // we cache the results of this call.
  MAX_CACHED_ZIP_CODES: 50,
  MAX_ZIP_CODE_VALIDATIONS_BEFORE_DEBOUNCE: 10,
  ZIP_CODE_VALIDATION_DEBOUNCE_TIME: 250,

  //////////////////////////
  // User Interface
  //////////////////////////

  MAX_LOADING_ROWS: 6,
  MAX_CACHED_SCENARIOS: 45,
  SHOW_TIMELINE_NUMBERS: true,

  // TODO Move field configurations into Kentico
  FORM_FIELDS: [
    field.LOAN_AMOUNT,
    field.HOME_VALUE,
    field.ZIP_CODE,
    field.CREDIT_SCORE,
    field.PROPERTY_TYPE,
    field.OCCUPANCY_TYPE,
    field.CASH_OUT_AMOUNT
  ],

  // Fallback values in case scenario is passed incorrectly
  BASE_SCENARIO: {
    loanPurpose: loanPurpose.REFINANCE,
    loanAmount: 400000,
    homeValue: 600000,
    zipCode: '94551',
    creditScore: 740,
    cashOutAmount: ''
  },

  //////////////////////////
  // Errors
  //////////////////////////

  DEFAULT_ERROR_TITLE: 'Something went wrong',
  DEFAULT_ERROR_MESSAGE:
    'We were unable to fetch your personalized mortgage rates, please try again later.',
  DEFAULT_ZIP_CODE_ERROR: 'Zip code not found'
};
